<template>
  <span :class="currentStatus">
    {{ this.value }}
  </span>
</template>

<script>
export default {
  name: "IndexStatus",
  props: ["status", "value"],
  computed: {
    currentStatus() {
      switch (this.status) {
        case 'GREAT':
          return 'text-purple font-bold"';
        case 'GOOD':
          return 'text-success';
        case 'FAIR':
          return 'text-warning';
        case 'BAD':
          return 'text-danger';
        default:
          return 'text-info';
      }
    },
  },
};
</script>
<style scoped>

</style>